import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { getRoleJwt, renderRedirect, basePort, getUsernameJwt, headers, isExpiredJwt, getJwtFromCookies, queryParameters, setAccessToken } from "../../module_auth/AuthService"
import { PaginationUrl } from "../../component/common/PaginationUrl"
import { NoticeCardAdmin } from "./NoticeCardAdmin"
import { useNavigate } from "react-router-dom"
import { isValidSearchPage } from '../common/BaseUtil';

export function NoticeListAdmin() {
    const [noticeList, setNoticeList] = useState([]);

    ////pagination
    const [pageList, setPageList] = useState([]);
    const [lastPage, setLastPage] = useState();
    const [activePageIndex, setActivePageIndex] = useState();
    const page = queryParameters.get("page")
    const next = queryParameters.get("next")
    const previous = queryParameters.get("previous")
    const navigate = useNavigate();
    ////pagination

    ////Authentification
    const [mbrId, setMbrId] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    ////Authentification

    useEffect(() => {
        if(getJwtFromCookies() == null 
            || isExpiredJwt(getJwtFromCookies())
            || getRoleJwt(getJwtFromCookies()) != "ROLE_ADMIN"){
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            loadEntity()
        }
    }, []);

    function loadEntity(){
        //currentPage
        let currentPage
        if(!isValidSearchPage(page)){
            let localStoragePage = localStorage.getItem("page")
            currentPage = !isValidSearchPage(localStoragePage) ? "1" : localStorage.getItem("page")
        } else {
            currentPage = page == "0" ? "1" : page
        }
        //end currentPage
        
        navigate("/notice_list_admin?page="  + currentPage);
        localStorage.setItem("page", currentPage)
        
        let url = basePort + '/get/notices/' + currentPage
        let activePageIndex = currentPage-1
        if(next != null){
            url = basePort + '/get/notices/next/' + currentPage
            activePageIndex = (currentPage-1)%2
        } else if(previous != null) {
            url = basePort + '/get/notices/previous/' + currentPage
            activePageIndex = (currentPage-1)%2
        }
        
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
            console.log(response.cardList)
            setNoticeList(response.cardList)
            
            ////pagination
            setPageList(response.displayPages)
            setLastPage(response.lastPage)
            setActivePageIndex(activePageIndex)
            ////pagination

          }).catch(error => console.log(error))
    }

    function clickRegister() {
        let url = "/notice_reg_admin"
        navigate(url);
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>공지사항 관리자</span></li>
                        </ol>
                    </div>
                    <div class="row" style={{display: 'flex'}}>
                        <div class="col-md-6 d-md-flex justify-content-xl-center align-items-xl-center justify-content-xxl-center">
                        <p class="d-flex justify-content-center justify-content-md-center align-items-xxl-center" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold', fontSize: '24px', marginTop: '15px'}}>공지사항</p>
                    </div>
                    <div class="col-md-6 d-flex d-md-flex justify-content-center justify-content-md-center align-items-md-center"><button class="btn btn-primary btn-sm text-end" type="button" style={{borderRadius: '5px'}} onClick={clickRegister}>등록</button></div>
                        </div>
                    <div class="container">
                        {noticeList.map((object, index) => (
                            <NoticeCardAdmin object={object} index={index}/>
                        ))}
                    </div>
                    
                    <PaginationUrl 
                        lastPage={lastPage}
                        page={page}
                        pageList={pageList}
                        activePageIndex={activePageIndex}
                        url={'notice_list_admin'}
                    />

                </section>
            </main>
        </div>
    );
}